import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@systemeio/components';
import { CopyInputValueButton } from 'shared/components/copy-input-value-button';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useSmsSubstitutes } from '../hooks/use-sms-substitutes';
const SKELETON_ROWS_COUNT = 13;
export const SmsSubstitutesBlock = () => {
  const $ = _c(10);
  const {
    t
  } = useLocoTranslation();
  const {
    substitutionData,
    isReady
  } = useSmsSubstitutes();
  let t0;
  if ($[0] !== t) {
    t0 = t("dashboard.sms.personalization_description");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <p className="text-text-secondary">{t0}</p>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isReady || $[5] !== substitutionData) {
    t2 = isReady ? <ul className="grid grid-cols-[auto_minmax(0,1fr)] gap-x-2 gap-y-2">{substitutionData.map(_temp)}</ul> : <SmsSubstitutesSkeleton />;
    $[4] = isReady;
    $[5] = substitutionData;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className="flex flex-col gap-6" data-test="sms-substitutes">{t1}{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
const SmsSubstitutesSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex animate-pulse flex-col gap-3">{Array.from({
        length: SKELETON_ROWS_COUNT
      }, _temp2)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(el) {
  return <li key={el.value} className="group col-span-2 grid grid-cols-subgrid items-start"><div className="flex items-center gap-1"><span className="bg-bg-tertiary text-text-primary rounded-sm px-2 py-1 whitespace-nowrap">{el.value}</span><CopyInputValueButton text={el.value} className="transition-base hover-capable:opacity-0 flex shrink-0 transition-opacity group-hover:opacity-100 focus-visible:opacity-100" /></div><span className="text-text-tertiary py-1">{el.label}</span></li>;
}
function _temp2(_, index) {
  return <Skeleton key={index} className="rounded-sm text-transparent">.</Skeleton>;
}